/**
 * @generated SignedSource<<57d11f4e2332b19d87c403e7d64ec868>>
 * @relayHash f896f939a1918da6870fd74a26e67107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TownsquareCreateRelationshipsInput = {
  relationships: ReadonlyArray<TownsquareRelationshipInput>;
};
export type TownsquareRelationshipInput = {
  from: string;
  to: string;
};
export type TownsquareDeleteRelationshipsInput = {
  relationships: ReadonlyArray<TownsquareRelationshipInput>;
};
export type goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation$variables = {
  createInput: TownsquareCreateRelationshipsInput;
  deleteInput: TownsquareDeleteRelationshipsInput;
};
export type goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation$data = {
  readonly townsquare: {
    readonly createRelationships: {
      readonly relationships: ReadonlyArray<{
        readonly from: string;
        readonly to: string;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
    readonly deleteRelationships: {
      readonly relationships: ReadonlyArray<{
        readonly from: string;
        readonly to: string;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation = {
  response: goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation$data;
  variables: goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteInput"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "success"
  },
  {
    "concreteType": "TownsquareRelationship",
    "kind": "LinkedField",
    "name": "relationships",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "from"
      },
      {
        "kind": "ScalarField",
        "name": "to"
      }
    ]
  }
],
v2 = [
  {
    "concreteType": "TownsquareMutationApi",
    "kind": "LinkedField",
    "name": "townsquare",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "createInput"
          }
        ],
        "concreteType": "TownsquareCreateRelationshipsPayload",
        "kind": "LinkedField",
        "name": "createRelationships",
        "plural": false,
        "selections": (v1/*: any*/)
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "deleteInput"
          }
        ],
        "concreteType": "TownsquareDeleteRelationshipsPayload",
        "kind": "LinkedField",
        "name": "deleteRelationships",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f",
    "metadata": {},
    "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d5d407c381c2f478408ef64adaf27177";

export default node;
